function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import has from 'ramda/src/has';
import pathOr from 'ramda/src/pathOr';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import CustomerCareLocaleKeys from '../../../../../../locales/keys';
import { BILLER_RULE_INSTANCE_TYPE, PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE } from '../../../../../../customercare.constants';
import { OfferingOptionBulkTypes } from '../../../../../../reducers/constants/convergent.biller.constants';
import { END_DATE_TYPES } from '../../../../../../reducers/constants/dashboard.constants';
import { updateLifeCycleDetails } from '../../../../../../reducers/actions/customer.actions';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { OfferingMetadataByIdSelector, OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { DashBoardLifeCycleStepsForOffersSelector, LifeCyclePricingPlanDetailsSelector, PricingPlanInLifeCycleForOffersSelector } from '../../../../../../reducers/selectors/selected.offering.order.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { getDiscountTooltipModel } from '../../../../../shared/tooltipTemplates/discount.tooltip.helper';
import { DiscountsMetadataMapSelector } from 'invision-core/src/components/metadata/discounts/discounts.selectors';
var OfferingOptionCtrl = /*#__PURE__*/function () {
  function OfferingOptionCtrl($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, OfferingOptionCtrl);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      customerCareKeys: CustomerCareLocaleKeys,
      discountToolTipTemplate: require('../../../../../shared/tooltipTemplates/discount.tooltip.html'),
      END_DATE_TYPES: END_DATE_TYPES,
      isOffCyclePaymentFailed: false,
      offeringMetadataLoaded: false,
      OfferingOptionBulkTypes: OfferingOptionBulkTypes,
      PRODUCT_CLASSIFICATIONS: PRODUCT_CLASSIFICATIONS,
      PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE: PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(OfferingOptionCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          discountsMetadataMap: DiscountsMetadataMapSelector(store),
          offeringMetadataById: OfferingMetadataByIdSelector(store),
          offeringMetadataPricingPlans: OfferingMetadataPricingPlansSelector(store),
          pricingPlanInLifeCycleForOffers: PricingPlanInLifeCycleForOffersSelector(store),
          lifeCyclePricingPlanDetails: LifeCyclePricingPlanDetailsSelector(store),
          lifeCycleStepsForOffers: DashBoardLifeCycleStepsForOffersSelector(store)
        };
      };
      var controllerActions = {
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        updateLifeCycleDetails: updateLifeCycleDetails
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.isOffCyclePaymentFailed = this.option.OffCycleDetail && this.option.OffCycleDetail.GracePeriodExpiryDate && this.option.OffCycleDetail.CurrentRenewalFailedAttempts;
      this.hasBillerItemBulkPrices = pathOr(0, ['BillerRulePrices', 'length'], this.option) !== 0;
      this.billerItemBulkPricesOrBillerTypeAmounts = this.hasBillerItemBulkPrices ? this.option.BillerRulePrices : this.option.BillerTypeAmounts || [];
      this.entitlementBris = this.findAllBillerItemFromType(BILLER_RULE_INSTANCE_TYPE.ENTITLEMENT);
      this.oneTimeBris = this.findAllBillerItemFromType(BILLER_RULE_INSTANCE_TYPE.ONETIME);
      this.recurringBris = this.findAllBillerItemFromType(BILLER_RULE_INSTANCE_TYPE.RECURRING);
      this.subscriptionBris = this.findAllBillerItemFromType(BILLER_RULE_INSTANCE_TYPE.SUBSCRIPTION);
      this.usageBris = this.findAllBillerItemFromType(BILLER_RULE_INSTANCE_TYPE.USAGE);
      this.usageOrEntitlementBris = this.usageBris.concat(this.entitlementBris);
      if (this.isUsageOrEntitlement) {
        this.billerRuleInstances = this.usageOrEntitlementBris;
      } else if (this.isOneTimeOption) {
        this.billerRuleInstances = this.getBillerRuleInstancesWithDiscountInfo(this.oneTimeBris, this.option, this.currencyCode);
      } else if (this.recurringBris.length) {
        this.billerRuleInstances = this.getBillerRuleInstancesWithDiscountInfo(this.recurringBris, this.option, this.currencyCode);
      } else {
        this.billerRuleInstances = this.subscriptionBris;
      }
      if (this.option.LifeCycleDetail !== undefined && Object.keys(this.option.LifeCycleDetail).length) {
        this.actions.retrieveOfferingsMetadata([this.option.OfferingId]);
      }
      this.lifeCycleDetailsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.lifeCycleDetailsPopupConfigApi = api;
        }
      };
      if (this.option.SubscriberProductServiceRelationship && this.option.SubscriberProductServiceRelationship.ServiceRelationshipType === PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE.CONSUMES && this.option.SubscriberProductServiceRelationship.ProviderPricingPlanId) {
        this.actions.retrieveOfferingsMetadata([this.option.SubscriberProductServiceRelationship.ProviderOfferingId.Value]).then(function () {
          _this.offeringMetadataLoaded = true;
        }).catch(function (error) {
          _this.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "closeLifeCycleDetailsPopup",
    value: function closeLifeCycleDetailsPopup() {
      this.lifeCycleDialogOpened = false;
      this.lifeCycleDetailsPopupConfigApi.close();
    }
  }, {
    key: "openLifeCycleDetailsPopup",
    value: function openLifeCycleDetailsPopup(option) {
      var _this2 = this;
      this.actions.updateLifeCycleDetails({
        offerId: option.OfferingId,
        lifeCycleId: option.LifeCycleDetail.LifeCycleId
      });
      this.pricingPlanInLifeCycleForOffers = this.state.pricingPlanInLifeCycleForOffers;
      this.lifeCyclePricingPlanDetails = Object.assign.apply(Object, [{}].concat(_toConsumableArray(this.state.lifeCyclePricingPlanDetails)));
      this.lifeCycleDialogOpened = true;
      this.currentLifeCycle = option.PricingPlanId;
      this.$timeout(function () {
        _this2.lifeCycleDetailsPopupConfigApi.open();
      });
    }
  }, {
    key: "getBillerRuleInstancesWithDiscountInfo",
    value: function getBillerRuleInstancesWithDiscountInfo(bris, option, currencyCode) {
      var _this3 = this;
      var brisWithDiscountInfo = [];
      bris.forEach(function (bri) {
        var briDiscounts = (option.Discounts || []).filter(function (discount) {
          return discount.BillerRuleConfigurationId === bri.BillerRuleConfigurationId && discount.IsActive;
        }).map(function (discount) {
          return getDiscountTooltipModel(discount, currencyCode, _this3.state.discountsMetadataMap);
        });
        brisWithDiscountInfo.push(Object.assign({}, bri, {
          discounts: briDiscounts
        }));
      });
      return brisWithDiscountInfo;
    }
  }, {
    key: "getItemQuantityBulk",
    value: function getItemQuantityBulk(bri) {
      // NOTE: `BulkQuantity` on the API resonse also contains the following for the time being:
      // - the non-bulk quantity
      // - the eBRI/uBRI quantity when there's no corresponding oRBI or rBRI
      if (this.hasBillerItemBulkPrices && !this.isUsageOrEntitlement) {
        var billerItemBulkPrice = this.getBillerItemBulkPrice(bri);
        return billerItemBulkPrice.Quantity || 0;
      }
      return this.isUsageOrEntitlement && this.option.BillerRulePrices && this.option.BillerRulePrices.length ? this.option.BillerRulePrices[0].Quantity : this.option.BulkQuantity;
    }
  }, {
    key: "getItemAmountBulk",
    value: function getItemAmountBulk(bri) {
      if (this.hasBillerItemBulkPrices) {
        var bulkAmount = this.getBillerItemBulkPrice(bri);
        return pathOr(0, ['Amount'], bulkAmount);
      }
    }
  }, {
    key: "getItemTotalAmountBulk",
    value: function getItemTotalAmountBulk() {
      var _this4 = this;
      // NOTE: `TotalAmount` will not be present on `BillerRulePrices` until the order is completed, so `Amount` is used instead
      var totalAmount = 0;
      if (this.hasBillerItemBulkPrices) {
        var billerItemBulkPrice = this.option.BillerRulePrices.find(function (bulkPrice) {
          return has('TotalAmount', bulkPrice) && _this4.billerRuleInstances.find(function (bri) {
            return bulkPrice.BillerRuleConfigurationId === bri.BillerRuleConfigurationId;
          });
        });
        if (billerItemBulkPrice) {
          totalAmount = undefined !== billerItemBulkPrice.TotalAmount ? billerItemBulkPrice.TotalAmount : billerItemBulkPrice.Amount || 0;
        }
      }
      return totalAmount;
    }
  }, {
    key: "getItemBulkType",
    value: function getItemBulkType(bri) {
      if (this.hasBillerItemBulkPrices) {
        var price = this.getBillerItemBulkPrice(bri);
        return price ? price.BulkType : 0;
      }
    }
  }, {
    key: "quickEdit",
    value: function quickEdit() {
      this.launchQuickEdit();
    }
  }, {
    key: "quickRemove",
    value: function quickRemove() {
      if (this.launchQuickRemove) {
        this.launchQuickRemove();
      } else {
        this.launchQuickEdit();
      }
    }
  }, {
    key: "showHoverActions",
    value: function showHoverActions() {
      return this.hasAdminAccess && this.enableQuickEdit() && !this.offerHasPendingChange;
    }
  }, {
    key: "getItemNameBulk",
    value: function getItemNameBulk(bri) {
      return this.getBillerTypeAmount(bri).BillerRuleConfigurationName;
    }
  }, {
    key: "findAllBillerItemFromType",
    value: function findAllBillerItemFromType(type) {
      return this.billerItemBulkPricesOrBillerTypeAmounts.filter(function (billerItemBulkPriceOrBillerTypeAmount) {
        return billerItemBulkPriceOrBillerTypeAmount.Type === type;
      });
    }
  }, {
    key: "getBillerTypeAmount",
    value: function getBillerTypeAmount(bri) {
      return this.option.BillerTypeAmounts.find(function (billerTypeAmount) {
        return billerTypeAmount.BillerRuleConfigurationId === bri.BillerRuleConfigurationId;
      });
    }
  }, {
    key: "getBillerItemBulkPrice",
    value: function getBillerItemBulkPrice(bri) {
      return this.option.BillerRulePrices.find(function (bulkPrice) {
        return bulkPrice.BillerRuleConfigurationId === bri.BillerRuleConfigurationId;
      });
    }
  }, {
    key: "discountTooltipText",
    value: function discountTooltipText(discounts) {
      return "".concat(discounts.length, " ").concat(i18n.translate(discounts.length === 1 ? CustomerCareLocaleKeys.DISCOUNT : CustomerCareLocaleKeys.DISCOUNTS_LABEL));
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export { OfferingOptionCtrl as default };